import { ISearchLimitOffset } from './ISearchLimitOffset';

export interface IFilterMessage extends ISearchLimitOffset {
    Ean?: string;
    LibelleMarque?: string;
    IdTypereponses?: number[];
    IdTypeDemandes?: number[];
    IdsUtilisateurscalipse?: number[];
    SortField?: string;
    IsDescending?:boolean;
    MesdemandesFilter?:boolean;
  }

  export const getDefaultFilterMessage = (pDefaultfilter?: IFilterMessage): IFilterMessage => ({
    Ean: pDefaultfilter?.Ean ??"",
    LibelleMarque: pDefaultfilter?.LibelleMarque ?? "",
    IdTypereponses:pDefaultfilter?.IdTypereponses ?? undefined,    
    Offset:pDefaultfilter?.Offset ?? 0,
    Limit: pDefaultfilter?.Limit ?? 10,
    SortField: pDefaultfilter?.SortField ?? "Id",
    IsDescending: pDefaultfilter?.IsDescending ?? true,
    IdTypeDemandes: pDefaultfilter?.IdTypeDemandes ?? undefined,
    IdsUtilisateurscalipse:pDefaultfilter?.IdsUtilisateurscalipse ?? undefined,
    MesdemandesFilter: pDefaultfilter?.MesdemandesFilter ?? false,

  });
  
  export const filterToQuery = (filter: IFilterMessage): IFilterMessage => {
    const dto: IFilterMessage = {};
 
    if (filter?.Ean !== undefined ) {
      dto.Ean = filter.Ean;
    } 

    if (filter?.LibelleMarque !== undefined ) {
      dto.LibelleMarque = filter.LibelleMarque;
    } 

    if (filter?.IdTypereponses !== undefined ) {
      dto.IdTypereponses = filter.IdTypereponses;
    } 
    if (filter?.IdTypeDemandes !== undefined ) {
      dto.IdTypeDemandes = filter.IdTypeDemandes;
    } 
    if (filter?.Limit) {
      dto.Limit = filter.Limit;
    } else {
      dto.Limit = 10;
    }
    if (filter?.Offset) {
      dto.Offset = filter.Offset;
    } else {
      dto.Offset = 0;
    }

    if (filter?.IsDescending) {
      dto.IsDescending = filter.IsDescending;
    } else {
      dto.IsDescending = false;
    }
  
    if (filter?.SortField) {
      dto.SortField = filter.SortField;
    } else {
      dto.SortField = "";
    }
    if (filter?.IdsUtilisateurscalipse !== undefined ) {
      dto.IdsUtilisateurscalipse = filter.IdsUtilisateurscalipse;
    } 
    if (filter?.MesdemandesFilter) {
      dto.MesdemandesFilter = filter.MesdemandesFilter;
    } else {
      dto.MesdemandesFilter = false;
    }
    localStorage.setItem("IFilterMessagesNotices", JSON.stringify(dto));
  
    return dto;
  };
  
  export const dtoToFilter = (dto: IFilterMessage): IFilterMessage => {
  
    return {
      Ean: dto.Ean,
      LibelleMarque: dto.LibelleMarque,
      IdTypereponses: dto.IdTypereponses,
      IdTypeDemandes: dto.IdTypeDemandes,
      IdsUtilisateurscalipse: dto.IdsUtilisateurscalipse,
      Limit: dto.Limit !== undefined ? dto.Limit : 10,
      Offset: dto.Offset !== undefined ? dto.Offset : 0,
      IsDescending: dto.IsDescending !== undefined ? dto.IsDescending : false,
      MesdemandesFilter: dto.MesdemandesFilter !== undefined ? dto.MesdemandesFilter : false,
      SortField: dto.SortField,
    };
  };
 